// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-programs {
  padding: 0px !important;
  position: relative;
}
.container-programs .btn-left {
  background-color: transparent !important;
  outline: none !important;
  cursor: pointer;
}
.container-programs .btn-right {
  background-color: transparent !important;
  outline: none !important;
  cursor: pointer;
}
.container-programs .btn-right::selection {
  background-color: transparent !important;
}
.container-programs .programs-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  font-family: "Lato", sans-serif !important;
  font-size: 22px;
}
.container-programs .programs-description {
  font-size: 16px;
  color: rgb(78, 125, 162) !important;
  cursor: pointer;
  font-weight: 400;
  width: 12rem;
  align-self: end;
}
.container-programs .columna {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px !important;
}
.container-programs .overflow-x {
  overflow-x: scroll;
  flex-wrap: nowrap;
}
.container-programs .overflow-x::-webkit-scrollbar {
  display: none;
}
.container-programs .programs-logged {
  margin-top: 2rem !important;
}
.container-programs .columna-box {
  background-color: #fff;
  margin: 10px;
  padding: 20px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  height: 150px;
  width: 150px;
  flex-wrap: nowrap !important;
}

.container-programs .columna-box-risk {
  background-color: #fff;
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  height: 150px;
  width: 150px;
  flex-wrap: nowrap !important;
}
.container-programs .img-fluid {
  max-width: 7rem !important;
  max-height: 7rem !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain !important;
  align-self: center !important;
}

@media (max-width: 576px) {
  .btn-left {
    display: none !important;
  }
  .btn-right {
    display: none;
  }
  .programs-title {
    margin-top: 0rem !important;
  }
  .programs-description {
    font-size: 12px !important;
    margin-left: 1rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/programs/programs.scss","webpack://./src/sass/layout/programs/programs.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAEA;EACE,uBAAA;EACA,kBAAA;ACDF;ADEE;EACE,wCAAA;EACA,wBAAA;EACA,eAAA;ACAJ;ADEE;EACE,wCAAA;EACA,wBAAA;EACA,eAAA;ACAJ;ADEE;EACE,wCAAA;ACAJ;ADGE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,0CErBG;EFsBH,eAAA;ACDJ;ADIE;EACE,eAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;ECFF,YAAY;EDKZ,eAAA;ACHF;AACA;EDKI,aAAA;EACA,sBAAA;EACA,uBAAA;ECHF,mBAAmB;EDKnB,uBAAA;ACHF;AACA;EACE,kBAAkB;EDKlB,iBAAA;ACHF;AACA;EDKE,aAAA;ACHF;AACA;EDKE,2BAAA;ACHF;AACA;EDKI,sBAAA;EACA,YAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;ECHF,YAAY;EDKZ,4BAAA;ACHF;;AAEA;EDKI,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;ECHF,aAAa;EDMb,YAAA;EACE,4BAAA;ACJJ;AACA;EACE,0BAA0B;EDiB5B,2BAAA;EACE,sBAAA;ECfA,uBDgBE;ECfF,8BAA8B;EDiB9B,6BAAA;ACfF;;AAEA;EACE;IACE,wBAAwB;EDiB1B;ECfA;IDiBE,aAAA;ECfF;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF","sourcesContent":["@import \"../../utilities/variables\";\n\n.container-programs {\n  padding: 0px !important;\n  position: relative;\n  .btn-left {\n    background-color: transparent !important;\n    outline: none !important;\n    cursor: pointer;\n  }\n  .btn-right {\n    background-color: transparent !important;\n    outline: none !important;\n    cursor: pointer;\n  }\n  .btn-right::selection {\n    background-color: transparent !important;\n  }\n\n  .programs-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    font-family: $Font;\n    font-size: 22px;\n  }\n\n  .programs-description {\n    font-size: 16px;\n    color: rgb(78, 125, 162) !important;\n    cursor: pointer;\n    font-weight: 400;\n    width: 12rem;\n  }\n\n  .columna {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0px !important;\n  }\n  .overflow-x {\n    overflow-x: scroll;\n    flex-wrap: nowrap;\n  }\n  .overflow-x::-webkit-scrollbar {\n    display: none;\n  }\n  .programs-logged {\n    margin-top: 2rem !important;\n  }\n  .columna-box {\n    background-color: #fff;\n    margin: 10px;\n    padding: 20px !important;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 12px;\n    height: 150px;\n    width: 150px;\n    flex-wrap: nowrap !important;\n  }\n  .columna-box-risk {\n    background-color: #fff;\n    margin: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 12px;\n    height: 150px;\n    width: 150px;\n    flex-wrap: nowrap !important;\n  }\n  .img-fluid {\n    max-width: 7rem !important;\n    max-height: 7rem !important;\n    width: auto !important;\n    height: auto !important;\n    object-fit: contain !important;\n    align-self: center !important;\n  }\n\n}\n\n\n\n@media (max-width: 576px) {\n  .btn-left {\n    display: none !important;\n  }\n  .btn-right {\n    display: none;\n  }\n  .programs-title {\n    margin-top: 0rem !important;\n  }\n  .programs-description {\n    font-size: 12px !important;\n    margin-left: 1rem;\n  }\n}\n",".container-programs {\n  padding: 0px !important;\n  position: relative;\n}\n.container-programs .btn-left {\n  background-color: transparent !important;\n  outline: none !important;\n  cursor: pointer;\n}\n.container-programs .btn-right {\n  background-color: transparent !important;\n  outline: none !important;\n  cursor: pointer;\n}\n.container-programs .btn-right::selection {\n  background-color: transparent !important;\n}\n.container-programs .programs-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 22px;\n}\n.container-programs .programs-description {\n  font-size: 16px;\n  color: rgb(78, 125, 162) !important;\n  cursor: pointer;\n  font-weight: 400;\n  width: 12rem;\n  align-self: end;\n}\n.container-programs .columna {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0px !important;\n}\n.container-programs .overflow-x {\n  overflow-x: scroll;\n  flex-wrap: nowrap;\n}\n.container-programs .overflow-x::-webkit-scrollbar {\n  display: none;\n}\n.container-programs .programs-logged {\n  margin-top: 2rem !important;\n}\n.container-programs .columna-box {\n  background-color: #fff;\n  margin: 10px;\n  padding: 20px !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 12px;\n  height: 150px;\n  width: 150px;\n  flex-wrap: nowrap !important;\n}\n\n.container-programs .columna-box-risk {\n  background-color: #fff;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border-radius: 12px;\n  height: 150px;\n  width: 150px;\n  flex-wrap: nowrap !important;\n}\n.container-programs .img-fluid {\n  max-width: 7rem !important;\n  max-height: 7rem !important;\n  width: auto !important;\n  height: auto !important;\n  object-fit: contain !important;\n  align-self: center !important;\n}\n\n@media (max-width: 576px) {\n  .btn-left {\n    display: none !important;\n  }\n  .btn-right {\n    display: none;\n  }\n  .programs-title {\n    margin-top: 0rem !important;\n  }\n  .programs-description {\n    font-size: 12px !important;\n    margin-left: 1rem;\n  }\n}\n\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
